var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTax1099Mimimize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27435_285397",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27435_285397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 15.0532L6.34619 9.39945L7.39994 8.3457L11.9999 12.9457L16.5999 8.3457L17.6537 9.39945L11.9999 15.0532Z",
    fill: "#F9F9F9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTax1099Mimimize);
export default __webpack_public_path__ + "static/media/tax1099_mimimize.4d348b6aeabd6dfe3244301bd4054c8d.svg";
export { ForwardRef as ReactComponent };